import React from 'react'
import OtcHistoryTable from '../../../components/transactionNew/otc/OTCHistoryTable'
import { useWindowSize } from '../../../modules/staking'
import { MOBILE_SIZE } from '../../../core/constants/common'
import ROtcHistoryTable from '../../../components/transactionNew/otc/ROtcHistoryTable'

const OtcHistory = () => {

    const { width } = useWindowSize()

    return (
        <>
            {width > MOBILE_SIZE ? <OtcHistoryTable /> : <ROtcHistoryTable />}
        </>
    )
}

export default OtcHistory